import { useTheme } from '@mui/material/styles';

export const TournamentSlot = ({ fill, fillOpacity = '1', stroke, strokeOpacity = '1', ...props }) => {
    const theme = useTheme();

    const finalFill = fill || theme.palette.figma.white[10];
    const finalStroke = stroke || theme.palette.figma.white[30];

    return (
        < svg xmlns="http://www.w3.org/2000/svg" width="84" height="20" viewBox="0 0 84 20" fill="none" >
            <path d="M82 20H8.01C7.48 20 6.97 19.79 6.6 19.41L0.59 13.4C0.21 13.03 0 12.52 0 11.99V2C0 0.9 0.9 0 2 0H75.99C76.52 0 77.03 0.21 77.4 0.59L83.41 6.6C83.79 6.98 84 7.48 84 8.01V18C84 19.1 83.1 20 82 20Z" fill={finalFill} fillOpacity={fillOpacity} />
            <path d="M2 0.5H75.9902C76.3885 0.500062 76.7685 0.657592 77.042 0.938477L83.0566 6.95312C83.3448 7.24132 83.4999 7.6153 83.5 8.00977V18C83.5 18.8239 82.8239 19.5 82 19.5H8.00977C7.61147 19.4999 7.23153 19.3424 6.95801 19.0615L0.938477 13.042L0.838867 12.9346C0.620518 12.6732 0.500054 12.3387 0.5 11.9902V2C0.5 1.17614 1.17614 0.5 2 0.5Z" stroke={finalStroke} strokeOpacity={strokeOpacity} />
        </svg >);
};

